export const AWS_API_URL = 'https://4urj3951sj.execute-api.ap-northeast-2.amazonaws.com';
export const AWS_PATH = 'temp/';
export const AWS_BUCKET = 'versuson-files';
export const AWS_EXPIRE = 90;
